import Loading from 'components/Loading';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { downloadFileService } from '../../../../services/API';
import { connect } from 'react-redux';

const fileSaver = require('file-saver');

@connect(function ({ app: { user } }) {
  return {
    inn: user.getIn(['data', 'inn']),
  };
})
export default class DownloadZip extends Component {
  static propTypes = {
    serverFileName: PropTypes.string,
    filename: PropTypes.string.isRequired,
    inn: PropTypes.string.isRequired,
  };

  static defaultProps = {
    filename: 'file.zip',
  };

  state = {
    error: false,
    loading: true,
  };

  started = false;

  componentDidMount() {
    this.startDownload();
  }

  componentDidUpdate() {
    if (this.started) {
      return;
    }
    this.startDownload();
  }

  startDownload() {
    const { serverFileName, filename, inn } = this.props;
    if (!inn) {
      return;
    }

    this.started = true;

    downloadFileService(serverFileName, inn)
      .then((res) => {
        if (res.isOk) {
          return res.data;
        }

        throw res.error;
      })
      .then((fileData) => {
        const blob = new Blob([fileData], {
          type: 'application/zip;charset=utf-8',
        });

        fileSaver.saveAs(blob, filename, true);
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        window.console.error(err);
        this.setState({
          error: true,
          loading: false,
        });
      });
  }

  getErrorMessage() {
    const { error, loading } = this.state;
    if (error) {
      return loading
        ? 'Документ формируется. Пожалуйста, подождите.'
        : 'Ошибка формирования документа.';
    }

    return 'Загрузка документа началась.';
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="page">
        <div className="page-title_block">
          <h2 style={{ textAlign: 'center' }}>{this.getErrorMessage()}</h2>
        </div>
        {loading ? <Loading /> : null}
      </div>
    );
  }
}
